$('.prices-schedule').each(function(key, block) {
  let $block = $(block);
  let languageId = getLanguage($block);
  $block.find('.schedule').
    not(`[data-language=${languageId}]`).
    css({display: 'none'});

  //bind changes
  let $languageTabs = $block.find('.schedule-select-language li');
  $languageTabs.click(function() {
    let languageId = parseInt($(this).data('id'));
    setLanguage($block, languageId);
  });
  $block.find('.select-language-list').change(function() {
    setLanguage($block, parseInt(this.value));
  });
});

$(document).on('click', '.entry-course-js', function(e) {
  e.preventDefault();

  let $scheduleBlock = $(this).closest('.schedule');
  let teacher = $scheduleBlock.find('.data-teacher').text();
  let start = $scheduleBlock.find('.schedule__start-date').text();
  let language = $scheduleBlock.closest('.prices-schedule').
    find('.schedule-select-language li.active').
    text();
  let id = parseInt($scheduleBlock.data('id'));
  let subtitle = teacher + ', старт ' + start + ', ' + language;

  openRecordFormModal({
    title: 'Запись на курс',
    subtitle,
    submitCallback({e, form}) {
      e.preventDefault();
      form.querySelectorAll('input').forEach(input => {
        input.changed = true;
      });

      if (!form.validate()) {
        return;
      }

      let data = $(form).serialize() +
        '&course_id=' + id +
        '&title=' + 'Новая запись на курс. ' + subtitle +
        '&page=' + document.location.href;

      $.post('/wp-json/api/v1/courses/entry', data, function() {
        if (typeof form.submitCallback === 'function') {
          form.submitCallback();
        }

        reachMetricGoal('COURSE_ENTRY');
        openModal('Спасибо за заявку. В ближайшее время мы с вами свяжемся');
      });
    },
  });
});

function getLanguage($block) {
  return parseInt($block.find('.select-language-list').val());
}

function setLanguage($block, languageId) {
  //обновляем выбор языка
  $block.find('.schedule-select-language li').removeClass('active');
  $block.find(`.schedule-select-language li[data-id=${languageId}]`).
    addClass('active');
  $block.find('.select-language-list').val(languageId);

  //изменяем видимый контент с анимацией
  $block.find('.schedule').not(`[data-language=${languageId}]`).fadeOut(500);
  setTimeout(function() {
    $block.find(`.schedule[data-language=${languageId}]`).fadeIn(500);
  }, 500);
}